import {createTheme} from '@mui/material/styles';
import {themeColor} from '@local/theme/color';

export const defaultTheme = createTheme({
  // sxの中にwidth, height, font-sizeみたいなpxのpropsも混在していて混乱の元だし
  // 脳内変換の分だけ効率落ちるし
  // どうせパーツ増えたら影響大きくて二度と変えられないから単位作るメリット薄いし
  // 最初から1にしちゃう。
  // 言いたいことは分かるんだけど。デザインファイルで管理してたら逆変換するだけだから恩恵あんまりないわ。
  // spacing: 1,
  // shape: {
  //   // これも同じ。
  //   borderRadius: 1,
  // },
  // と思ったんだけどMuiコンポーネント自体がこれ前提にできてるから意味なかった。なんのためにテーマ存在するん。。

  palette: {
    primary: {
      main: themeColor.brand.primary,
      // コントラストの自動計算がギリギリ黒になるので白に上書き
      contrastText: '#fff',
    },
    secondary: {
      main: themeColor.background.base,
      contrastText: themeColor.brand.primary,
    },
    error: {
      main: themeColor.state.error,
    },
    success: {
      main: themeColor.state.success,
    },
  },
  typography: {
    fontFamily: ['Roboto', 'Noto Sans Jp', 'sans-serif'].join(','),
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          ':before': {
            content: 'none',
          },
          ':after': {
            borderBottom: 'none',
          },
        },
        input: {
          padding: '16.5px 14px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
        },
      },
      variants: [{props: {size: 'large'}, style: {height: 56}}],
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          // これがデフォかどうか確認してから。
          // fontSize: 16,
          // lineHeight: 1.5,
          // やりすぎかなぁ
          // やりすぎだなぁ
          // whiteSpace: 'pre-wrap',
        },
      },
      variants: [
        {
          // デフォがこれだった。これの上書きは影響範囲大きすぎた。
          props: {variant: 'body1'},
          style: {
            // fontSize: 16,
            // lineHeight: 1.8,
          },
        },
        {
          props: {variant: 'body2'},
          style: {
            fontSize: 13,
          },
        },
        {
          props: {variant: 'h2'},
          style: {
            fontSize: 32,
            fontWeight: 700,
            lineHeight: 1.5,
          },
        },
        {
          props: {variant: 'h3'},
          style: {
            fontSize: 24,
            fontWeight: 700,
            lineHeight: 1.5,
          },
        },
        {
          props: {className: 'headline'},
          style: {
            textAlign: 'center',
          },
        },
        {
          props: {variant: 'h4'},
          style: {
            fontSize: 20,
            fontWeight: 700,
            lineHeight: 1.4,
          },
        },
        // spで定義されてるやつがpc画面にあるからpcとして定義する（spにするとレスポンシブ対応するときに変な感じになるため）
        // と思ったけどspとpcが共存してた。やばみ。
        // デスクトップ用デザインでsp使われてるやつはひとつずつ下げることにする。figmaにもコメント済み。
        // デザイン修正までは辻褄あわせる上でタグが不足したら現状使ってないsubtitle1とか色々消費しながらあとで置換できるようにする。
        // これはsp/h4の内容
        // ってやってたけど後述のように後ろも定義されてて詰んだため書き換え
        {
          props: {variant: 'h4', className: 'h-sp'},
          style: {
            fontWeight: 700,
            fontSize: 16,
          },
        },
        // これはsp/h5のデザイン
        {
          props: {variant: 'h5', className: 'h-sp'},
          style: {
            fontWeight: 700,
            fontSize: 14,
            lineHeight: 1.6,
          },
        },
        // 早速無理があったのでspクラスと組み合わせることにする。
        // 統一したほうがいいけどデザインも変わりそうだから今はこれだけ。
        {
          props: {variant: 'h3', className: 'h-sp'},
          style: {
            fontWeight: 700,
            fontSize: 18,
          },
        },
        {
          props: {className: 'h-label'},
          style: {
            fontWeight: 400,
            fontSize: 12,
            lineHeight: 1.1,
            letterSpacing: '0.08em',
          },
        },
      ],
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          color: themeColor.brand.primary,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // うーーーん共通化したかったけどPaper使ってるMuiコンポーネント多すぎて困る
          // Muiの中でも共通のコンポーネントのスタイル変えるのやばそう
          // borderRadius: 24,
          // 色はむしろMui製パーツでも統一したほうがよさそう
          color: 'black',
        },
      },
      // これが答え・・・か・・・？
      variants: [{props: {className: 'h'}, style: {borderRadius: 24}}],
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderRadius: '0 !important',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          // 全部これっぽく見えるから検証進む前に全部オーバーライドしてみる。
          // 定義ないとつらいな
          fontWeight: 700,
          fontSize: 14,
          minWidth: 82,
        },
      },
      variants: [
        {
          // cautionだけ分けて色決めたほうがよさそう
          props: {size: 'small', className: 'h-caution'},
          style: {lineHeight: '20px', paddingLeft: 8, paddingRight: 8, height: 17},
        },
        {
          props: {variant: 'filled', color: 'success'},
          style: {backgroundColor: `${themeColor.state.success}1a`, color: themeColor.state.success},
        },
        {
          props: {variant: 'filled', color: 'error'},
          style: {backgroundColor: `${themeColor.state.error}1a`, color: themeColor.state.error},
        },
        {
          props: {variant: 'filled', color: 'default'},
          style: {
            backgroundColor: `${themeColor.text.sub}1a`,
            color: themeColor.text.sub,
          },
        },
      ],
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: 'separate',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '0.85rem',
        },
      },
    },
  },
});
